import { IClient } from "intake_shared/src/types";
import * as React from "react";
import { Dialog } from "../../../bits/Dialog/Dialog";
import { Select } from "../../../bits/Select/Select";
import moment from "../../../../../utils/app_moment";
import { CacheContext } from "../../../../../contexts/CacheContext";
import { findLabelByPracticeId } from "../../../../../utils/utils";
import Loader from "../../../bits/Loader/Loader";

interface ConsentEmailProps {
    client: IClient | undefined;
    show: boolean;
    onClose: () => void;
    onConfirm: (value: string) => void;
    loading: boolean;
}

type Option = {
    label: React.ReactNode;
    value: string;
};

export default function ConsentEmail({
    client,
    show,
    onClose,
    onConfirm,
    loading,
}: ConsentEmailProps) {
    const [selectedAppointmentId, setSelectedAppointmentId] = React.useState("");
    const olc = React.useContext(CacheContext);

    const handleConfirm = async () => {
        if (selectedAppointmentId) {
            try {
                await onConfirm(selectedAppointmentId);
                setSelectedAppointmentId("");
                onClose();
            } catch (error) {
                console.error("Error sending consent email:", error);
            }
        }
    };

    const appointmentOptions = React.useMemo(() => {
        const allDepartmentsAndServices = olc?.allDepartmentAndServices || {};

        const appointmentsToDisplay = [
            ...(client?.held_bookings || []),
            ...(client?.confirmed_bookings || []),
        ];
        return appointmentsToDisplay?.map((b) => {
            const appointmentPractice = findLabelByPracticeId(
                b.practice_id ||
                    (process.env.REACT_APP_MANTLE_PRACTICE_ID as string),
                allDepartmentsAndServices
            );

            return {
                label: (
                    <>
                        {appointmentPractice && (
                            <span
                                style={{
                                    display: "inline-block",
                                    padding: "2px 6px",
                                    marginRight: 8,
                                    borderRadius: 999,
                                    backgroundColor: "#EEF3F7",
                                    fontSize: 11,
                                }}
                            >
                                {appointmentPractice}
                            </span>
                        )}
                        {b.clinician_display_name} / {b.requested_service} /{" "}
                        {moment(b.starting_date || b.start).format(
                            "MMMM Do, h:mm A"
                        )}
                    </>
                ),
                value: b.id,
            };
        });
    }, [
        client?.held_bookings,
        client?.confirmed_bookings,
        olc?.allDepartmentAndServices,
    ]);

    return (
        <>
            <Loader show={loading} />
            <Dialog
                open={show}
                onClose={onClose}
                title="Send Consent Email"
                onCancel={onClose}
                onSave={handleConfirm}
                isSubmitBtnDisabled={!selectedAppointmentId}
                saveText="Send Email"
            >
                <form>
                    <Select
                        label="Select appointment to send consent email for"
                        options={appointmentOptions}
                        value={appointmentOptions?.find(
                            (o) => o.value === selectedAppointmentId
                        )}
                        onChange={(val) =>
                            setSelectedAppointmentId((val as Option).value)
                        }
                        isLongListInDialog
                    />
                </form>
            </Dialog>
        </>
    );
}
